import Contacts from './contacts/Contacts';
import s from './footer.module.css';
import SubscriptionForm from './subscriptionForm/SubscriptionForm';
import FooterMenuList from './FooterMenuListst/FooterMenuList';
import menu from '../../JSON/menu.json';
import support from '../../JSON/support.json';
import company from '../../JSON/company.json';
import Logo from './logo/Logo';
import SocialLincs from './SocialLincs/SocialLincs';
import Container from '../Container/Container';
import Ribbon from '../Ribbon/Ribbon';

const Footer = () => {
  return (
    <footer className={s.footer}>
      <div className={s.ribbon}>
        <Ribbon />
      </div>
      <Container>
        <div className={s.container}>
          <div className={s.containerNav}>
            <Logo />
            <Contacts />
            <SocialLincs />
          </div>
          <div className={s.listMenuLeft}>
            <FooterMenuList title="Каталог" menu={menu} />
          </div>
          <div className={s.listMenuRight}>
            <div className={s.supportList}>
              <FooterMenuList title="Підтримка" menu={support} />
            </div>
            <FooterMenuList title="Компанія" menu={company} />
          </div>
          <SubscriptionForm />
        </div>
      </Container>
      <div className={s.copirightWrapper}>
        <Container>
          <div className={s.copiright}>
            © Gamepro, 2021. Усі права захищенні
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
